import tw from 'tailwind-styled-components'

export const TwColumnChart = tw.div<{$className?: string}>`
  flex
  flex-col
  mb-8
  pt-16
  pb-8
  h-full
  ${p => (p.$className ? p.$className : '')}
`

export const TwColumnChartHeader = tw.div`
  text-14
  w-full
  flex
  items-center
  justify-between
  mb-8
  flex-wrap
`

export const TwColumnsWrapper = tw.div`
  flex-1
  flex
  
  border-0
  border-solid
  border-b-1
  border-grey-l60
`

// TODO! 112 - move to an func argument
export const TwColumn = tw.div`
  w-[112px]
  flex
  items-end
`

export const TwColumnInner = tw.div`
  w-40
  min-h-[4px]
  mx-auto
  rounded-t-4
`

export const TwColumnTitles = tw.div`
  mt-8
  w-full
  flex
`

export const TwColumnTitleInner = tw.div`
  w-[112px]
  text-12
  text-secondary
  text-center
`
